export const styles = {
    tabsContainer: {
        padding: '0 16px 0 0'
    }
};
